module.exports = false;


/*****************
 ** WEBPACK FOOTER
 ** /usr/src/sentry/~/babel-core/~/core-js/modules/$.library.js
 ** module id = 163
 ** module chunks = 0
 **/